import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import CategoriesState from '../../types/CategoriesState'
import Category from '../../types/Category'

const mutations: MutationTree<CategoriesState> = {
  [types.SET_PARTNERS_CATEGORIES] (state, payload: Category[]) {
    state.categories = payload
  },
  [types.SET_CURRENT_PARTNER_CATEGORY] (state, payload: Category) {
    state.current_category = payload
  },
  [types.RESET_CURRENT_CATEGORY] (state) {
    state.current_category = null
  },
  [types.SET_CATEGORIES_LOADED_FOR_LOCATION] (state, payload: string | null) {
    state.loadedForLocationCode = payload
  }
}

export default mutations
